import type { TaleezUser } from '../types/taleez-user.js';
import { getCookieRaw } from './cookie.js';
import { logger } from '../utils/logger.js';

const TALEEZ_USER_COOKIE_NAME = 'taleez_user';

/**
 * Lit le cookie `taleez_user` et retourne les données parsées.
 * Retourne null si le cookie est absent ou mal formé.
 */
export function getTaleezUser(): TaleezUser | null {
  const raw = getCookieRaw(TALEEZ_USER_COOKIE_NAME);
  if (!raw) return null;

  try {
    const parsed: unknown = JSON.parse(raw);
    // Validation minimale : doit avoir au moins un id
    if (typeof parsed === 'object' && parsed !== null && 'id' in parsed) {
      return parsed as TaleezUser;
    }
    logger.warn('taleez_user cookie présent mais format invalide');
    return null;
  } catch (error) {
    logger.warn('Erreur parsing cookie taleez_user:', error);
    return null;
  }
}
